const initState = {
    isLoading: false,
    data: [],
    page: 1,
    error: null,
  };
  
  const TransListReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_LOADING_TRANS":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_DATA_TRANS":
        return {
          ...state,
          isLoading: false,
          data: action.payload.data,
        };
      case "SET_ERROR_TRANS":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      case "RESET_TRANS":
        return{
          ...state,
          isLoading: false,
          data: [],
          error: null,
        }
      default:
        return state;
    }
  };
  
  export default TransListReducer;